import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getUserById, updateUser } from "../../services/api";
import Breadcrumbs from "../../components/BreadCrumbs";

const UserUpdate = () => {
  const { id } = useParams(); // Obtener el ID del usuario de la URL
  const navigate = useNavigate();
  const [userData, setUserData] = useState({
    nombre: "",
    email: "",
    password: "",
  });

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const user = await getUserById(id); // Obtener los detalles del usuario
        setUserData(user); // Establecer los datos del usuario en el estado
      } catch (error) {
        console.error("Error fetching user:", error);
      }
    };
    fetchUser();
  }, [id]);

  const handleChange = (e) => {
    setUserData({
      ...userData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await updateUser(id, userData); // Actualizar los detalles del usuario
      navigate("/users"); // Redirigir a la lista de usuarios
    } catch (error) {
      console.error("Error updating user:", error);
    }
  };

  // Definir las rutas para los breadcrumbs
  const breadcrumbPaths = [
    { name: "Dashboard", url: "/dashboard" },
    { name: "Users", url: "/dashboard/users" },
    {
      name: "Update user",
      url: "/dashboard/users/update/" + id,
    },
  ];

  return (
    <>
      <h2>Actualizar Usuario</h2>
      <Breadcrumbs paths={breadcrumbPaths} />

      <form onSubmit={handleSubmit}>
        <div className="mb-3 row">
          <label className="col-sm-2 col-form-label">Nombre</label>
          <div class="col-sm-10">
            {" "}
            <input
              type="text"
              className="form-control"
              name="nombre"
              value={userData.nombre}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="mb-3 row">
          <label className="col-sm-2 col-form-label">Email</label>
          <div class="col-sm-10">
            <input
              type="email"
              className="form-control"
              name="email"
              value={userData.email}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="mb-3 row">
          <label className="col-sm-2 col-form-label">Equipo</label>
          <div class="col-sm-10">
            <input
              type="text"
              className="form-control"
              name="equipo"
              value={userData.equipo}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="mb-3 row">
          <label className="col-sm-2 col-form-label">Rol</label>
          <div class="col-sm-10">
            <select
              className="form-select"
              name="rol"
              value={userData.rol}
              onChange={handleChange}
              required
            >
              <option value="">Seleccionar...</option>
              <option value="admin">Administrador</option>
              <option value="developer">Developer</option>
              <option value="tester">Tester</option>
            </select>
          </div>
        </div>
        <div className="mb-3 row">
          <label className="col-sm-2 col-form-label">Password</label>
          <div class="col-sm-10">
            <input
              type="password"
              className="form-control"
              name="password"
              value={userData.password}
              onChange={handleChange}
            />
          </div>
        </div>
        <div style={{ textAlign: "end" }}>
          <button type="submit" className="btn btn-primary">
            Actualizar Usuario
          </button>
        </div>
      </form>
    </>
  );
};

export default UserUpdate;
